IntlMessageFormat.__addLocaleData({"locale":"tn","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"tn-BW","parentLocale":"tn"});
IntlMessageFormat.__addLocaleData({"locale":"tn-ZA","parentLocale":"tn"});
